import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';
import { PageType, PageTypes } from 'strapi/page/types';

import BreadCrumb from './BreadCrumb';
import { collectBreadcrumbParams } from './collector';

export class BreadcrumbsComponentBuilder extends ComponentBuilder {
  public key = '__.custom.breadcrumbs' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const page =
      await inputs.fetchManager.addRequestOptionsAndWaitForResponse<unknown>(
        {}
      );
    const breadcrumbLinks = collectBreadcrumbParams(
      '' as PageType,
      page as PageTypes
    );

    return breadcrumbLinks?.props.links || null;
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <BreadCrumb links={inputs} />;
    } else {
      return null;
    }
  }
}
